import { Alert, Box, Typography, useLayout } from '@capitalise/ui-design-system';
import useDisplayFundingSearchDriver, {
  FundingSearchDriverPosition,
} from 'modules/Business/hooks/useDisplayFundingSearchDriver';
import useMediaQuery from 'modules/Business/hooks/useMediaQuery';
import AnimatedToggleBox from './AnimatedToggleBox';
import DriverSidePanel from './DriverSidePanel';

const FundingSearchDriverHeader = ({ didScroll }: { didScroll: boolean }) => {
  const { isMobile } = useMediaQuery();
  const { setRightBarOverlay } = useLayout();
  const { visible, removeBanner, creditScore } = useDisplayFundingSearchDriver({
    position: FundingSearchDriverPosition.HEADER,
    ref: null,
  });

  const openSidePanel = () => {
    setRightBarOverlay(<DriverSidePanel />, { size: isMobile ? 'fullWidth' : 'large' });
  };

  return (
    <AnimatedToggleBox open={visible} overflow="hidden">
      <Alert
        type="info"
        closable
        actionLabel="More info"
        onActionClick={openSidePanel}
        onCloseClick={removeBanner}
        actionVariant="outlined"
        contentProps={
          didScroll ? { flexWrap: 'no-wrap', display: 'grid', gridTemplateColumns: '60% auto' } : {}
        }
      >
        <Box flexDirection="column" flexPosition="start center">
          <Typography size="body-16" color="grey-900">
            See your full Experian business credit profile
            {!didScroll && ' as banks and lenders see it.'}
          </Typography>
        </Box>
      </Alert>
    </AnimatedToggleBox>
  );
};

export default FundingSearchDriverHeader;
